import type { Translations } from "../keys.js";

export const ja = {
  eyebrow: "IBKR アクティビティステートメント",
  title: "損益比レポート",
  uploadMark: "Flex XML",
  uploadTitle: "IBKR XML をドロップまたは選択",
  uploadBody: "氏名、口座、住所は画面上でマスクされます。",
  nfaDisclaimer: "学習と取引レビュー目的のみで、投資助言ではありません。",
  chooseFile: "ファイル選択",
  account: "口座",
  name: "氏名",
  neutralName: "モモ",
  period: "期間",
  baseCurrency: "基準通貨",
  closed: "決済",
  executions: "約定",
  netRealized: "実現損益",
  winRate: "勝率",
  payoffRatio: "損益比",
  expectancy: "期待値",
  executionRecords: "約定記録",
  canceledOrders: "取消注文",
  medianHoldingDays: "保有日数中央値",
  commissionDrag: "手数料",
  closedTradeSum: "決済取引合計",
  grossProfitLoss: "総利益 / 総損失",
  averageWinLoss: "平均利益 / 平均損失",
  perClosedTrade: "決済ごとの平均",
  flexTradeRecords: "Flex XML の Trade 記録",
  flexCanceledRecords: "Flex XML の取消 Order 記録",
  noCanceledRecords: "取消注文は含まれていません",
  holdingReview: "Holding",
  holdingReviewTitle: "保有期間と損益比分析",
  holdingReviewHint: "建玉と決済を照合し、保有期間別に PF、損益比、勝率を比較します。",
  holdingPeriod: "保有期間",
  holdingIntraday: "日中",
  holdingSwing: "1-7 日",
  holdingPosition: "8-30 日",
  holdingLongTerm: "30 日以上",
  directionReview: "Direction",
  directionReviewTitle: "ロング / ショート分析",
  directionReviewHint: "戦略エクスポージャーで決済取引を分け、優位性のある側を確認します。",
  longPosition: "ロング",
  shortPosition: "ショート",
  neutralPosition: "中立",
  equityCurve: "資産曲線",
  dailyRealized: "日次実現損益",
  payoff: "損益比",
  winLossDistribution: "勝敗分布",
  periodPerformance: "期間別成績",
  periodHint: "緑の棒は利益、赤の棒は損失です。PF と損益比は下の表で確認できます。",
  weekly: "週次",
  monthly: "月次",
  periodColumn: "期間",
  monthColumn: "月",
  realized: "実現",
  profitFactor: "Profit Factor",
  pf: "PF",
  payoffShort: "損益比",
  trades: "件数",
  assetBreakdown: "資産別",
  assetBreakdownTitle: "株式 / オプション統計",
  asset: "資産",
  medianPnl: "損益中央値",
  average: "平均",
  optionReview: "オプション",
  optionReviewTitle: "原資産別オプション復盤",
  underlying: "原資産",
  date: "日付",
  dateCount: "日数",
  daysShort: "日",
  hoursShort: "時間",
  minutesShort: "分",
  weakestSession: "最弱セッション",
  intradaySessionNoData: "通常時間の決済なし",
  intradaySessionTitle: "寄り・昼・引けの勝率分析",
  intradaySessionHint: "決済時刻で寄り、昼、引けに分け、実現損益、中央値、平均、PF、損益比、勝率を比較します。",
  weekdayReviewTitle: "曜日別の取引成績",
  weekdayReviewHint: "通常時間内の決済と自動満期を曜日別に比べ、損益比が最も良い日と悪い日を確認します。",
  weekday: "曜日",
  weekdaySunday: "日曜日",
  weekdayMonday: "月曜日",
  weekdayTuesday: "火曜日",
  weekdayWednesday: "水曜日",
  weekdayThursday: "木曜日",
  weekdayFriday: "金曜日",
  weekdaySaturday: "土曜日",
  bestDay: "最良",
  worstDay: "最悪",
  session: "時間帯",
  sessionMorning: "寄り",
  sessionMidday: "昼",
  sessionLate: "引け",
  autoExpiry: "自動満期",
  optionLifecycle: "満期 / 決済",
  optionLifecycleRegularClose: "通常決済",
  optionLifecycleEp: "満期失効",
  optionLifecycleEx: "権利行使",
  optionLifecycleA: "割当",
  optionLifecycleCD: "現金決済",
  optionLifecycleAEx: "自動権利行使",
  optionLifecycleMEx: "手動権利行使",
  optionLifecycleGEA: "相殺満期 / 割当",
  discipline: "規律",
  disciplineRisk: "規律リスク",
  largeLossAlert: "大きな損失の警告",
  largeLossDiscipline: "まず止まり、規律を守る",
  largeLossRule: "この日の合計損失は現在のリスクしきい値を超えています。取り返すためにサイズを上げる前に、予定した損切り、日次最大損失、停止ルールを確認してください。",
  worstLossDay: "最大日次損失",
  symbols: "銘柄",
  symbolPerformance: "銘柄ランキング",
  page: "ページ",
  previousPage: "前のページ",
  nextPage: "次のページ",
  offlineCoach: "オフラインコーチ",
  offlineAdvice: "オフライン助言",
  bestLoserWins: "良い負け方が勝ちにつながる",
  theme: "テーマ",
  language: "言語",
  dark: "ダーク",
  light: "ライト",
  stock: "株式",
  option: "オプション",
  other: "その他",
  cash: "現金",
  future: "先物",
  unknown: "不明",
  lossBucketSmall: "小損",
  lossBucketMedium: "中損",
  lossBucketLarge: "大損",
  winBucketSmall: "小勝",
  winBucketMedium: "中勝",
  winBucketLarge: "大勝",
  chartEmpty: "表示できる決済取引がありません",
  dailyChartLegend: "棒：日次、線：累積",
  periodChartLegend: "PF 点、基準 1.00、上限",
  importFailed: "読み込み失敗",
  profitStatus: "利益",
  lossStatus: "損失",
  flatStatus: "横ばい",
  costStatus: "コスト",
  toggleDetails: "詳細を表示",
  "error.invalid_flex_xml": "IBKR Flex XML ファイルをアップロードしてください。",
  "advice.profit_factor_below_one.title": "PF が 1 を下回っています",
  "advice.profit_factor_below_one.body": "現在の PF は {profitFactor} です。利益合計が損失合計をまだ上回っていません。取引回数を増やす前に、大きな損失、満期損失、無計画な追加を減らしてください。",
  "advice.profit_factor_thin_edge.title": "PF の余裕が薄い状態です",
  "advice.profit_factor_thin_edge.body": "現在の PF は {profitFactor} です。取引は可能でも、数回の制御不能な損失で期間全体が消えます。日次最大損失、最終退出時刻、一時停止ルールを先に決めてください。",
  "advice.profit_factor_healthy.title": "PF 構造は比較的健全です",
  "advice.profit_factor_healthy.body": "現在の PF は {profitFactor} です。頻度をむやみに上げず、再現性のある銘柄、時間帯、セットアップを見つけて高品質な取引だけを残してください。",
  "advice.winrate_and_payoff_weak.title": "勝率と損益比を同時に弱くできません",
  "advice.winrate_and_payoff_weak.body": "勝率は {winRate}、損益比は {payoffRatio} です。命中率も平均利益も十分に補えていません。エントリー前に目標余地と損切り幅を確認してください。",
  "advice.high_winrate_weak_payoff.title": "勝率が弱い損益比を補っています",
  "advice.high_winrate_weak_payoff.body": "勝率は {winRate} ですが、損益比は {payoffRatio} です。悪い 1 回が良い数回を消します。方向性より出口とリスク定義の問題であることが多いです。",
  "advice.overtrade_loss_days.title": "負け日で加速が見えます",
  "advice.overtrade_loss_days.body": "{days} 日で高い取引数とマイナス損益が同時に出ました。最初の損失後の取引が計画内か、取り返し目的かを別に確認してください。",
  "advice.auto_expiry_losses.title": "自動満期損失はノイズではありません",
  "advice.auto_expiry_losses.body": "{count} 件の自動満期損失が含まれています。満期ゼロは管理可能なリスクとして扱い、許容できる最終退出時刻を書き出してください。",
  "advice.good_loser_base.title": "良い負け方が次の取引を守ります",
  "advice.good_loser_base.body": "平均利益は {avgWin}、平均損失は {avgLoss} です。計画内の損失はコスト、計画外の損失はリスク定義を狭めるサインです。",
  "advice.detach_outcome_from_ego.title": "損益を自尊心から切り離す",
  "advice.detach_outcome_from_ego.body": "復盤ではまず、この損失は計画通りだったかを確認してください。はいならコスト、いいえなら規律の問題です。",
  "advice.large_tail_losses.title": "最大損失を先に小さくする",
  "advice.large_tail_losses.body": "{count} 件の損失が {threshold} を超えました。PF 改善の最短路は勝率向上より、週全体を壊す尾部損失の削減であることが多いです。",
  "advice.asset_group_relative_edge.title": "{stronger} に相対的な優位があります",
  "advice.asset_group_relative_edge.body": "オプション PF は {optionProfitFactor}、株式 PF は {stockProfitFactor} です。安定した PF の領域に資金と注意を置き、弱い側が試し玉や感情取引でないか確認してください。",
  "advice.option_sample_dominant.title": "現在のサンプルは主にオプションです",
  "advice.option_sample_dominant.body": "オプション PF は {optionProfitFactor}、勝率は {optionWinRate} です。総損益だけでなく、満期、権利行使、最終時間帯、IV 変化を分けて復盤してください。",
  "advice.stock_sample_dominant.title": "現在のサンプルは主に株式です",
  "advice.stock_sample_dominant.body": "株式 PF は {stockProfitFactor}、勝率は {stockWinRate} です。オプションと混ぜる前に、保有時間、損切り一貫性、追いかけ買いを確認してください。",
  "advice.weak_option_underlying_days.title": "弱いオプション銘柄日を個別に確認",
  "advice.weak_option_underlying_days.body": "{rows}。これらは集計表より実際の意思決定に近い組み合わせです。方向、エントリー時刻、満期接近を先に確認してください。",
  "advice.clean_sample.title": "サンプルをきれいに保つ",
  "advice.clean_sample.body": "単一の資産クラスが明確に足を引っ張ってはいません。クリーンな決済サンプルを増やし、周期性、銘柄集中、セットアップ安定性を確認してください。",
} satisfies Translations;
